import addStyles from '../addStyles';
import { DOCUMENT_CSS_TEMPLATE } from 'constants/documentCSSTemplate';
import * as CONTENT_STYLING from 'constants/contentStyling';

const addDocumentCSS = async (
  targetDocument,
  readerSettingsValues,
  theme,
  fixedWidth,
  fixedHeight,
) => {
  const id = 'redshelf-document-css';
  const CONFIG_ATTRIBUTE = 'data-redshelf-configuration-values';
  let template = DOCUMENT_CSS_TEMPLATE;
  const configurationValues = {
    HIGHLIGHT_COLOR_1: readerSettingsValues.highlightColor1.background,
    HIGHLIGHT_COLOR_2: readerSettingsValues.highlightColor2.background,
    HIGHLIGHT_COLOR_3: readerSettingsValues.highlightColor3.background,
    HIGHLIGHT_COLOR_4: readerSettingsValues.highlightColor4.background,
    HIGHLIGHT_HOVER_1: readerSettingsValues.highlightColor1.hover,
    HIGHLIGHT_HOVER_2: readerSettingsValues.highlightColor2.hover,
    HIGHLIGHT_HOVER_3: readerSettingsValues.highlightColor3.hover,
    HIGHLIGHT_HOVER_4: readerSettingsValues.highlightColor4.hover,
    HIGHLIGHT_BORDER_1: readerSettingsValues.highlightColor1.border,
    HIGHLIGHT_BORDER_2: readerSettingsValues.highlightColor2.border,
    HIGHLIGHT_BORDER_3: readerSettingsValues.highlightColor3.border,
    HIGHLIGHT_BORDER_4: readerSettingsValues.highlightColor4.border,
    SPOTLIGHT_COLOR: readerSettingsValues.spotlightColor.background,
    SELECTION_COLOR: readerSettingsValues.selectionColor.background,
    ACTIVE_SELECTION_COLOR: fixedWidth
      ? 'rgba(99, 123, 147, 0.25)'
      : readerSettingsValues.selectionColor.background,
    MIX_BLEND_MODE:
      CONTENT_STYLING.OPTIONS.THEME_NIGHT === theme ? 'difference' : 'multiply',
    FIXED_WIDTH_RULE: fixedWidth ? `min-width: ${fixedWidth}px;` : '',
    FIXED_HEIGHT_RULE: fixedHeight ? `min-height: ${fixedHeight}px;` : '',
  };

  const configurationValuesString = JSON.stringify(configurationValues);

  for (let key in configurationValues) {
    const regexp = new RegExp('\\b' + key, 'g');
    template = template.replace(regexp, configurationValues[key]);
  }

  const existingElement = targetDocument.getElementById(id);

  if (
    existingElement?.getAttribute(CONFIG_ATTRIBUTE) ===
    configurationValuesString
  ) {
    // The document css has already been added with the most up to date configuration
    return;
  }

  // The css either hasn't been added or has been added previously with outdated values.
  // Remove the outdated css if it exists.
  existingElement?.remove();

  const attributes = { id };
  attributes[CONFIG_ATTRIBUTE] = configurationValuesString;

  // Prepend the latest css
  await addStyles(targetDocument, attributes, template, true);
};

export default addDocumentCSS;
